import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NiceSelectModule } from "ng-nice-select";
import { ImageCropperModule } from 'ngx-image-cropper';
import { FilePondModule, registerPlugin } from 'ngx-filepond';
import { environment } from '@teem/environments/environment';
import { AgmCoreModule } from '@agm/core';
import { DragDropModule } from '@angular/cdk/drag-drop';

import { StoreInformationComponent } from '@teem/store-module/store-information.component';
import { StoreInformationRoutingModule } from '@teem/store-module/store-information-routing.module';
import { CoreModule } from '@teem/core/core.module';
import { ProductInformationComponent } from '@teem/store-module/components/product-information/product-information.component';
import { ProductComponent } from '@teem/store-module/components/product-information/components/product/product.component';
import { DeliveryComponent } from '@teem/store-module/components/product-information/components/delivery/delivery.component';
import { DeliveryDurationComponent } from '@teem/store-module/components/product-information/components/delivery-duration/delivery-duration.component';
import { OtoTabComponent } from '@teem/store-module/components/product-information/components/oto-tab/oto-tab.component';
import { PromoCodeComponent } from '@teem/store-module/components/product-information/components/promo-code/promo-code.component';
import { GoogleLocationModalComponent } from '@teem/store-module/modals/google-location-modal/google-location-modal.component';
import { BranchModalComponent } from '@teem/store-module/modals/branch-modal/branch-modal.component';

// Import filepond plugins
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type/dist/filepond-plugin-file-validate-type';
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation/dist/filepond-plugin-image-exif-orientation';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview';
import FilePondPluginImageCrop from 'filepond-plugin-image-crop/dist/filepond-plugin-image-crop';
import FilePondPluginImageResize from 'filepond-plugin-image-resize/dist/filepond-plugin-image-resize';
import FilePondPluginImageTransform from 'filepond-plugin-image-transform/dist/filepond-plugin-image-transform';
import FilePondPluginImageEdit from 'filepond-plugin-image-edit/dist/filepond-plugin-image-edit';
import { ServiceInformationComponent } from './components/service-information/service-information.component';
import { BranchesModule } from '@teem/web-market/store-branches/branches.module';
// import { BranchTemplateComponent } from '../store-branches/branch-template/branch-template.component';

registerPlugin(
  FilePondPluginFileValidateType,
  FilePondPluginImageExifOrientation,
  FilePondPluginImagePreview,
  FilePondPluginImageCrop,
  FilePondPluginImageResize,
  FilePondPluginImageTransform,
  FilePondPluginImageEdit
);

@NgModule({
  declarations: [
    StoreInformationComponent,
    ProductInformationComponent,
    ServiceInformationComponent,
    GoogleLocationModalComponent,
    BranchModalComponent,
    ProductComponent,
    DeliveryComponent,
    OtoTabComponent,
    DeliveryDurationComponent,
    PromoCodeComponent,
    // BranchTemplateComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    CoreModule,
    FilePondModule,
    ReactiveFormsModule,
    NiceSelectModule,
    ImageCropperModule,
    StoreInformationRoutingModule,
    BranchesModule,
    DragDropModule,
    AgmCoreModule.forRoot({
      apiKey: environment.googleApiKey,
      libraries: ['geometry', 'places']
    })
  ]
})
export class StoreInformationModule { }
